import Swiper from "swiper";
import {Pagination, Navigation, Autoplay, EffectFade} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

Swiper.use([Pagination, Navigation, Autoplay, EffectFade]);

export default class CustomizableSwiper {
    constructor(
        swiperContainerSelector,
        swiperOptions
    ) {
        this.swiperContainer = swiperContainerSelector;
        this.swiperOptions = swiperOptions;

        this.initListeners();
    }

    initListeners() {
        window.addEventListener('resize', () => {
            this.createSwiper();
        }, {passive: true});

        document.addEventListener('DOMContentLoaded', () => {
            this.createSwiper();
        });
    }

    createSwiper() {
        if (this.swiper != undefined && !this.swiper.destroyed) {
            this.swiper.destroy();
        }

        const swiper = document.querySelector(this.swiperContainer);
        if (swiper && (this.swiper === undefined || this.swiper.destroyed)) {
            this.swiper = new Swiper(this.swiperContainer, this.swiperOptions);
        }
    }
}
